import { Flex, Typography } from "antd";
import { TemplatesBlock } from "./TemplatesBlock";

export const DocumentTemplates = () => {
  return (
    <>
      <Typography.Title>Шаблоны документов</Typography.Title>
      <Flex gap="large" wrap>
        <div style={{ flex: 1 }}>
          <TemplatesBlock />
        </div>
      </Flex>
    </>
  );
};
